<template lang="html">
  <div class="input-tags">
    <div @mousedown.prevent="toggleDropdown">
    <span class="icon-left">
      <i class="fa fa-map-marker"></i>
    </span>
      <input
              name="destinations"
              autocomplete="off"
              class="dark-placeholder-text"
              :placeholder="placeholderText"
              :aria-label="'Search by ' + placeholder"
              ref="search"
              v-model="search"
              @focus="onFocus"
              @blur="onBlur"
              @keydown="onKeyDown"
              @keyup.esc="onEscape"
              @keydown.up.prevent="highlightPointerUp"
              @keydown.enter.prevent="onEnterKey(highlightPointer)"
              @keydown.down.prevent="highlightPointerDown"
              type="text">
    </div>
    <ul ref="dropdownMenu" v-show="dropdownOpen" class="dropdown-menu unstyled-list search-list">
      <li v-for="(option, index) in filteredOptions"
          v-bind:key="index"
          :class="{
            selected: isSelectedOption(option.name) > -1,
            highlighted: highlightPointer == index,
            top: option.type == 'region',
            child: option.type == 'subregion',
            bottom: option.type == 'city',
          }"
          @mouseover="highlightPointer = index">
        <a @mousedown.prevent="select(option)">
          {{ option.name }}
        </a>
      </li>

      <!-- <li v-if="!filteredOptions.length" class="no-options">
        <slot name="no-options">No matching results.</slot>
      </li> -->
    </ul>
  </div>
</template>

<script>
import Bus from "./Bus.js";
import Fuse from "fuse.js";
import highlightPointer from "./mixins/highlightPointer.js";

export default {
  name: "input-tags",

  mixins: [highlightPointer],

  props: {
    value: {
      default: null
    },

    category: {
      type: String,
      required: true
    },

    options: {
      type: Array,
      default: function() {
        return ["Option 1", "Option 2"];
      }
    },

    placeholder: {
      type: String,
      default: ""
    },

    clearSearchOnSelect: {
      type: Boolean,
      default: true
    },

    closeOnSelect: {
      type: Boolean,
      default: true
    },

    selectMultiple: {
      type: Boolean,
      default: true
    },

    showSelected: {
      type: Boolean,
      default: false
    }
  },

  data: function() {
    return {
      search: "",
      dropdownOpen: false,
      activatePredictiveSearch: true,
      selected: [],
      fuse: null,
      fuseOptions: {
        shouldSort: true,
        threshold: 0.6,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 4,
        keys: [
          { name: "name", weight: 0.9 },
          { name: "parent_name", weight: 0.2 }
        ]
      }
    };
  },

  mounted: function() {
    let vm = this;
    vm.fuse = new Fuse(vm.options, vm.fuseOptions);


    Bus.$on("option-deselect", function(option, category) {
      let i = vm.isSelectedOption(option.name);
      if (category == vm.category && i > -1) {
        vm.deselect(i);
      }
    });

    Bus.$on("option-sync", function(data) {
      if (data[vm.category]) {

        for (let i = 0; i < data[vm.category].length; i++) {
          if (vm.isSelectedOption(data[vm.category][i].name) < 0) {
            vm.selected.push(data[vm.category][i].name);
          }
        }
      }
    });
  },

  watch: {
    options: function(opt) {
      this.fuse = new Fuse(opt, this.fuseOptions);
    }
  },

  computed: {
    filteredOptions: function() {

      if (this.fuse && this.search !== "") {
        let filteredOptions = [];
        let filtered = this.fuse.search(this.search);

        // extract the item object
        filtered.forEach(function(option){
          filteredOptions.push(option.item);
        });

        return filteredOptions;
      }

      return this.options;
    },

    placeholderText: function() {
      if (this.showSelected) {
        if (this.selectMultiple && this.selected.length > 1) {
          return this.selected[0] + this.addtlSelectedText();
        } else if (this.selected.length) {
          return this.selected[0];
        }
      }

      //if !showSelected just show category name instead
      return this.placeholder;
    }
  },

  methods: {
    addtlSelectedText: function() {
      if (this.selected.length < 1) {
        return false;
      }

      // return this.selected.name;
      return " +" + (this.selected.length - 1) + " More";
    },

    onEnterKey: function(i) {
      let option = this.filteredOptions[i];
      this.select(option);
    },

    select: function(option) {

      let i = this.isSelectedOption(option.name);

      if (i > -1) {
        this.deselect(i);
        Bus.$emit("option-deselect", option, this.category);
      } else {
        if (this.selectMultiple) {
          this.selected.push(option["name"]);
        } else {
          if (this.selected.length) {
            Bus.$emit("option-deselect", this.selected[0], this.category);
          }
          this.selected[0] = option.name;
        }
        Bus.$emit("option-select", option, this.category);
        this.activatePredictiveSearch = true;
      }

      if (this.clearSearchOnSelect) {
        this.search = "";
      }
    },

    deselect: function(i) {
      this.selected.splice(i, 1);
    },

    isSelectedOption: function(name) {
      return this.selected.indexOf(name);
    },

    toggleDropdown: function() {
      //extend to have conditional check
      if (this.dropdownOpen) {
        this.$refs.search.blur();
      } else {
        this.$refs.search.focus();
        this.dropdownOpen = true;
      }
    },

    onEscape: function() {
      if (!this.search.length) {
        this.$refs.search.blur();
      } else {
        this.search = "";
      }
    },

    onBlur: function() {
      if (this.activatePredictiveSearch) {
        Bus.$emit("search:blur");
        this.dropdownOpen = false;

        let closestSelectedItem = (this.filteredOptions.length > 0 ) ? this.filteredOptions[0] : {name:'Central Coast / Valley'};
        // this.select(closestSelectedItem);
      }
      else {
        this.dropdownOpen = false;
      }
    },

    onKeyDown: function(event){
      let keyPressed = event.keyCode;
      if (keyPressed != 13) {
        this.activatePredictiveSearch = true;
      }
    },

    onFocus: function() {
      this.dropdownOpen = true;
    },

    log(item) {
      console.log(item)
    }
  }
};
</script>

<style lang="css">
  .top {
    font-weight: bold;
  }
</style>
